import { FACTORY_ADDRESS as V2_FACTORY_ADDRESS } from '@uniswap/v2-sdk'
import { FACTORY_ADDRESS as V3_FACTORY_ADDRESS } from '@uniswap/v3-sdk'

import { constructSameAddressMap } from '../utils/constructSameAddressMap'
import { SupportedChainId } from './chains'

type AddressMap = { [chainId: number]: string }

export const UNI_ADDRESS: AddressMap = constructSameAddressMap('0xBb1388eD79d611210794cd626120710720306B0f')
export const MULTICALL_ADDRESS: AddressMap = {
  ...constructSameAddressMap('0x1F98415757620B543A52E61c46B32eB19261F984', [
    SupportedChainId.POLYGON_MUMBAI,
    SupportedChainId.POLYGON,
  ]),
}
export const V2_FACTORY_ADDRESSES: AddressMap = constructSameAddressMap(V2_FACTORY_ADDRESS)

export const V2_ROUTER_ADDRESS: AddressMap = constructSameAddressMap('0x7a250d5630B4cF539739dF2C5dAcb4c659F2488D')
export const V3_ROUTER_ADDRESS: AddressMap = constructSameAddressMap('0xE592427A0AEce92De3Edee1F18E0157C05861564', [
  SupportedChainId.POLYGON,
  SupportedChainId.POLYGON_MUMBAI,
])
export const SWAP_ROUTER_ADDRESSES: AddressMap = constructSameAddressMap('0x68b3465833fb72A70ecDF485E0e4C7bD8665Fc45', [
  SupportedChainId.POLYGON,
  SupportedChainId.POLYGON_MUMBAI,
])

export const MERKLE_DISTRIBUTOR_ADDRESS: AddressMap = {
  [SupportedChainId.POLYGON]: '0x090D4613473dEE047c3f2706764f49E0821D256e',
}
export const ARGENT_WALLET_DETECTOR_ADDRESS: AddressMap = {
  [SupportedChainId.POLYGON]: '0xeca4B0bDBf7c55E9b7925919d03CbF8Dc82537E8',
}
export const V3_CORE_FACTORY_ADDRESSES: AddressMap = constructSameAddressMap(V3_FACTORY_ADDRESS, [
  SupportedChainId.POLYGON_MUMBAI,
  SupportedChainId.POLYGON,
])
export const QUOTER_ADDRESSES: AddressMap = constructSameAddressMap('0xb27308f9F90D607463bb33eA1BeBb41C27CE5AB6', [
  SupportedChainId.POLYGON_MUMBAI,
  SupportedChainId.POLYGON,
])
export const NONFUNGIBLE_POSITION_MANAGER_ADDRESSES: AddressMap = constructSameAddressMap(
  '0xC36442b4a4522E871399CD717aBDD847Ab11FE88',
  [SupportedChainId.POLYGON_MUMBAI, SupportedChainId.POLYGON]
)
export const ENS_REGISTRAR_ADDRESSES: AddressMap = {
  [SupportedChainId.POLYGON]: '0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e',
}

// New contracts

export const MULTICALLV2_ADDRESS: AddressMap = {
  [SupportedChainId.POLYGON]: '0x406837df92C4Fe8e824Ab558F7292B31D955A611',
  [SupportedChainId.POLYGON_MUMBAI]: '0xF2e8cE0B41aee041Cc4C7C1Cf7194aBdFF5BD601',
}

/* export const TR_PRESALE_ADDRESS: AddressMap = {
  [SupportedChainId.POLYGON]: '0x436263bA4d6156e4ABbc966CCd75735E0F3f6be8',
  [SupportedChainId.POLYGON_MUMBAI]: '0x9ee02C884766E38dB22365Cd6BBAcE000c795C77',
}

export const PLAY_REWARDS_ADDRESS: AddressMap = {
  [SupportedChainId.POLYGON]: '0x173E125D2Fd43e3B8b62959FB23E5BcbC7635Dc6',
  [SupportedChainId.POLYGON_MUMBAI]: '0x52597d0f698F741BCCd170b55De9ed276DB1c44A',
} */

export const BANK_ADDRESS: AddressMap = {
  [SupportedChainId.POLYGON]: '0x9E7F6161443BB2bca728Eb0c40ba41591A148d8e',
  [SupportedChainId.POLYGON_MUMBAI]: '0xa2D8e89edeDD0674726ca1971beE65f8f140c2D9',
}

export const REFERRALS_VAULT_ADDRESS: AddressMap = {
  [SupportedChainId.POLYGON]: '0x9aa3d28A9a0986193F17Cdc4fb84a852eccd5716',
  [SupportedChainId.POLYGON_MUMBAI]: '0xd17347916C484E079d3104ebE60bdE6093177683',
}

export const REFERRALS_HUB_ADDRESS: AddressMap = {
  [SupportedChainId.POLYGON]: '0x64CC87d263564F3BE1fE1Ef593FEFAE402CB0070',
  [SupportedChainId.POLYGON_MUMBAI]: '0x3Aa2DF07BcB3dE2f2b84e516eA7a092Dfd2612E0',
}

export const STAKE_POOL_ADDRESS: AddressMap = {
  [SupportedChainId.POLYGON]: '0xdAA0237fAfA8c49e6975414a706E923233758E27',
  [SupportedChainId.POLYGON_MUMBAI]: '0x349de278dd72e509060C3a1C610bA682B3A096c2',
}

export const PAIR_ADDRESS: AddressMap = {
  [SupportedChainId.POLYGON]: '0x8aAA94b04fAb31558b59826Cf34b74a62a774EEA',
  [SupportedChainId.POLYGON_MUMBAI]: '0x0b94431B96D8B7C6CD0AB4a65de3b819A3833A1C',
}

export const BANK_OPERATOR_ADDRESS: AddressMap = {
  [SupportedChainId.POLYGON]: '0x2C78671feF162a26a7fAbBD76F54E9b5CB2f937E',
  [SupportedChainId.POLYGON_MUMBAI]: '0xB0582227a56E4cB0627c536d867F871D8c170857',
}

// Games

export const DICE_ADDRESS: AddressMap = {
  [SupportedChainId.POLYGON]: '0xDAE7591F20CCBc83657b551C36c67a6B361f9719',
  [SupportedChainId.POLYGON_MUMBAI]: '0xc18a32aF9389c516002257CBC96C967Ef8346216',
}

export const ROULETTE_ADDRESS: AddressMap = {
  [SupportedChainId.POLYGON]: '0xe636c7f3EBB193AA45c55f818c87097eC96D5F37',
  [SupportedChainId.POLYGON_MUMBAI]: '0x8FfA220E2c387840E637418Af84a2a618458434B',
}

export const SPORT_ADDRESS: AddressMap = {
  [SupportedChainId.POLYGON]: '0x6bD5100DF749420Fb3d0c26c98EB32CfCba635F9',
  [SupportedChainId.POLYGON_MUMBAI]: '0x53560AF0DFdB0876e888D33C5134e831c3796526',
}
